import { __rest } from "tslib";
import React from 'react';
import { isFunction } from '~/utils';
import { useMergeRefs } from '~/hooks';
import { usePopoverProvider } from './popover-context';
import Slot from '../slot/slot';
const POPOVER_CONTENT_NAME = 'vulcanui-popover-content';
function Content(props) {
    const { children } = props, restProps = __rest(props, ["children"]);
    const { getPopoverProps, refs, isMounted, popoverStyles } = usePopoverProvider('PopoverContent');
    const ref = useMergeRefs([refs.setFloating, isFunction(children) ? null : children.props.ref]);
    const componentProps = Object.assign(Object.assign({}, getPopoverProps(restProps)), { ref, style: popoverStyles });
    if (!isMounted)
        return null;
    if (isFunction(children))
        return children(componentProps);
    return (React.createElement(Slot, Object.assign({}, getPopoverProps(restProps), { ref: ref, style: popoverStyles }), children));
}
Content.displayName = 'Popover.Content';
Content.toString = () => `.${POPOVER_CONTENT_NAME}`;
export default Content;
//# sourceMappingURL=popover-content.js.map